ixModuleRouting("impactx.company", {
    "/companydata/:id": {
        template: "<ixa-company-data></ixa-company-data>",
        process: "EditCompany",
        workspace: "admin",
    },
    "/clientcompanydata/:id": {
        template: "<ixa-client-company-data></ixa-client-company-data>",
        process: "EditCompany",
        workspace: "admin",
    },
    "/companyrelation/:id": {
        template: "<ixa-company-relation></ixa-company-relation>",
        process: "EditCompany",
        workspace: "admin",
    },
    "/companylist": {
        template: "<ixa-company-list></ixa-company-list>",
        process: "CompanyList",
        workspace: "admin",
    },
    "/manufacturerlist": {
        template: "<ixa-manufacturer-list></ixa-manufacturer-list>",
        process: "CompanyList",
        workspace: "admin",
    },
    "/supplierlist": {
        template: "<ixa-supplier-list></ixa-supplier-list>",
        process: "CompanyList",
        workspace: "admin",
    },
    "/suppliercreation": {
        template: "<ixa-supplier-creation></ixa-supplier-creation>",
        process: "SupplierCreation",
        workspace: "admin",
    },
    "/companyinterface/:id": {
        template: "<ixa-company-interface></ixa-company-interface>",
        process: "EditCompany",
        workspace: "admin",
    },
    "/clientcompanynews": {
        template: "<ixa-client-company-news></ixa-client-company-news>",
        process: "EditClientCompanyNews",
        workspace: "admin",
    },
    "/companygreetingcardlayout/:id": {
        template: "<ixa-company-greeting-card-layout></ixa-company-greeting-card-layout>",
        process: "CompanyGreetingCardAdministration",
        workspace: "admin",
    },
});
